import Decimal from 'decimal.js';
import OrderAdjustmentForm from './OrderAdjustmentForm.vue'

export default OrderAdjustmentForm;

export enum AdjustmentType {
  Fee,
  Discount,
}
